import {Header} from "../Navigation/Header";
import {AuthRoutes} from "../../Keycloak/AuthRoutes";

const Layout = () => {

    return (
        <div>
            <Header />
            <main>
                <AuthRoutes />
            </main>
        </div>
    )
}

export {Layout}